import { defineComponent, ref, computed } from '@vue/composition-api';
import __vue_component__ from '../SdsFilterBarItem/SdsFilterBarItem.vue.js';
import __vue_component__$1 from '../SdsButtonIcon/SdsButtonIcon.vue.js';
import { useScrollingTracker } from '../utils/useScrollingTracker.js';

var script = defineComponent({
    emits: ['filterSelect'],
    props: {
        filterItems: {
            type: Array,
            required: true,
        },
        activeFilter: {
            type: String,
            required: true,
        },
        isCentered: {
            type: Boolean,
            required: false,
            default: false,
        },
        styling: {
            type: String,
            required: false,
            default: 'brand',
        },
        showNav: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
    setup: function (props) {
        var filterBarRef = ref();
        var _a = useScrollingTracker(filterBarRef, {
            direction: 'horizontal',
        }), isScrollable = _a.isScrollable, isScrolled = _a.isScrolled;
        var isFilterBarCentered = computed(function () { return props.isCentered && !isScrollable.value && !isScrolled.value; });
        function scrollNext() {
            var _a;
            (_a = filterBarRef.value) === null || _a === void 0 ? void 0 : _a.scrollBy({
                left: 100,
                behavior: 'smooth',
            });
        }
        function scrollPrevious() {
            var _a;
            (_a = filterBarRef.value) === null || _a === void 0 ? void 0 : _a.scrollBy({
                left: -100,
                behavior: 'smooth',
            });
        }
        return {
            filterBarRef: filterBarRef,
            isFilterBarCentered: isFilterBarCentered,
            isLeftOverlayShown: computed(function () { return props.showNav && isScrolled.value; }),
            isRightOverlayShown: computed(function () { return props.showNav && isScrollable.value; }),
            scrollNext: scrollNext,
            scrollPrevious: scrollPrevious,
        };
    },
    components: {
        SdsFilterBarItem: __vue_component__,
        SdsButtonIcon: __vue_component__$1,
    },
});

export default script;
